export interface IStep {
    getName(): string
    getStepNumber(): number
    setNavigable(bool: boolean): void
    getNavigable(): boolean 
    setFinalized(bool: boolean): void
    getFinalized(): boolean
}

class Step implements IStep {
    private stepNumber: number
    private navigable = false
    private finalized = false
    private name: string

    constructor(stepNumber: number, name: string) {
        if (stepNumber < 0) throw new Error("stepNumber cannot be negative")
        this.stepNumber = stepNumber
        this.name = name
    }

    public getName(): string {
        return this.name
    }

    public getStepNumber(): number {
        return this.stepNumber
    }

    public setNavigable(bool: boolean) {
        this.navigable = bool
    }
    public getNavigable(): boolean {
        return this.navigable
    }
    public setFinalized(bool: boolean) {
        this.finalized = bool
    }
    public getFinalized(): boolean {
        return this.finalized
    }
}

export default Step